import Model, { attr, belongsTo } from '@ember-data/model';
import type { ModelRegistry } from 'ember-data/types/registries/model';

type ExternalIcalSyncStatus = 'successful' | 'failing' | 'failed' | 'pending';

export default class ExternalIcalModel extends Model {
  @attr('string') channel!: string;
  @attr('string') url!: string;
  @attr('string') name!: string;
  @attr('number') numberOfBookings!: number;

  @attr('date') lastSyncAttemptedAt!: Date;
  @attr('date') lastSuccessfulSyncAt!: Date;
  @attr('number') failedSyncAttempts!: number;
  @attr('string') syncStatus!: ExternalIcalSyncStatus;

  @belongsTo('property', { inverse: 'externalIcals', async: false })
  property!: ModelRegistry['property'];
}

declare module 'ember-data/types/registries/model' {
  interface ModelRegistry {
    'external-ical': ExternalIcalModel;
  }
}
